import { DAOButton } from "components/button";
import Selection, { getWalletOptions } from "components/input/select-input";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducer/store";
import { bulkSetUserInfo } from "reducer/user.slice";
import { Modal, } from "semantic-ui-react";
import { api, ui, utils } from "services";
import { useTranslation } from "react-i18next";
import { ImSpinner } from "react-icons/im";
import { CustomerInterface, TransactionInterface } from "interfaces";
import Config from "config";
import StakePeriod from "./stake-period";

export default function Unstake({ open, onClose, unit, onSuccess, setRecentTransaction, stakeConfig, trigger, setTrigger, usdtGuaranteeRequired }: any) {
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [getFeeLoading, setGetFeeLoading] = useState(false);
  const [available, setAvailable] = useState(0);
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const loginType = useSelector((state: RootState) => state.logintype);
  const wallets = useSelector((state: RootState) => state.wallets);
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(0);
  const [transactionFee, setTransactionFee] = useState(0);
  const [openStakePeriod, setOpenStakePeriod] = useState(false)
  const { t } = useTranslation();

  useEffect(() => {
    if (user?.[CustomerInterface.id]) {
      let data = getWalletOptions(wallets) ?? [];
      setOptions(data);
      let idx = data.find((i) => i.value == loginType)
      if (idx) {
        setValue(idx.value)
      } else {
        data.length > 0 && setValue(data[0].value)
      }
    }
  }, [wallets, loginType])

  useEffect(() => {
    if (unit === "MAG") {
      setAvailable(user?.[CustomerInterface.staked_mag]);
    } else if (unit === "MSTR") {
      setAvailable(user?.[CustomerInterface.mstr]);
    } else if (unit === "USDT") {
      setAvailable(Math.max((Number(user?.[CustomerInterface.usdt_guaranteed]) - Number(usdtGuaranteeRequired)), 0));
    }
  }, [unit, user]);

  async function onSubmit() {
    if (!amount) {
      return;
    }
    setLoading(true);
    switch (unit) {
      case "MSTR":
        try {
          let { customerInfo, transactionInfo } = await api.post("/dao/withdraw-mstr", {
            amount,
            logintype: loginType
          });
          dispatch(bulkSetUserInfo(customerInfo));
          setRecentTransaction(transactionInfo[TransactionInterface.id])
          ui.alertSuccess(
            "Transaction is on processing!",
            <>
              Your transaction will be claimable after {new Date(transactionInfo[TransactionInterface.claim_at].toString()).toLocaleTimeString("en-us", Config.FormattedTime as any)}
            </>
          );
          window.scrollTo(0, document.body.scrollHeight);
          close();
          setTimeout(async () => {
            console.log("load")
            await api.getMSTRBalance();
          }, 3000)
          onSuccess();
        } catch (error: any) {
          ui.alertFailed("Transaction failed !", "Please try again later !");
          close();
        }
        break;
      case "MAG":
        try {
          let { customerInfo, transactionInfo } = await api.post("/dao/withdraw-mag", {
            amount,
            logintype: loginType
          });
          dispatch(bulkSetUserInfo(customerInfo));
          setRecentTransaction(transactionInfo[TransactionInterface.id])
          ui.alertSuccess(
            "Transaction is on processing!",
            <>
              Your transaction will be claimable after {new Date(transactionInfo[TransactionInterface.claim_at].toString()).toLocaleTimeString("en-us", Config.FormattedTime as any)}
            </>
          );

          window.scrollTo(0, document.body.scrollHeight);
          close();
          setTimeout(async () => {
            await api.getMAGBalance();
          }, 3000)
          onSuccess();
        } catch (error) {
          ui.alertFailed("Transaction failed !", "Please try again later !");
          close();
        }
        break;
      case "USDT":
        try {
          let { customerInfo, transactionInfo } = await api.post("/dao/withdraw-usdt", {
            amount,
            logintype: loginType
          });
          dispatch(bulkSetUserInfo(customerInfo));
          setRecentTransaction(transactionInfo[TransactionInterface.id])
          ui.alertSuccess(
            "Transaction is on processing!",
            <>
              Your transaction will be claimable after {new Date(transactionInfo[TransactionInterface.claim_at].toString()).toLocaleTimeString("en-us", Config.FormattedTime as any)}
            </>
          );

          window.scrollTo(0, document.body.scrollHeight);
          close();
          setTimeout(async () => {
            await api.getUSDTBalance();
          }, 3000)
          onSuccess();
        } catch (error) {
          ui.alertFailed("Transaction failed !", "Please try again later !");
          close();
        }
        break;
    }
  }
  function close() {
    setAmount(0);
    setLoading(false);
    setTransactionFee(0);
    onClose();
    setOpenStakePeriod(false);
  }

  const getMinimumToken = (unit: string) => {
    if (unit === "MAG") {
      return 1e-8;
    } else if (unit === "MSTR") {
      return 1e-8;
    } else {
      return 1e-8;
    }
  }

  return (
    <>
      <Modal
        size="small"
        open={open && !openStakePeriod}
        style={{ width: "unset" }}
      >
        <div
          className="max-w-[564px] w-screen"
        >
          <div className="text-red cursor-pointer absolute float-right right-4 top-3"
            onClick={() => {
              if (!loading) {
                close();
              }
            }}
          >
            <img src="/assets/images/icons/close-popup.png" alt="close" className="" />
          </div>
          <div className="max-w-[564px] w-screen bg-black-secondary pb-8">
            <div>
              <div className="text-center text-white text-xl py-6 font-extrabold main-font-bold">
                {t("unstake")}
              </div>
              <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-9" />

              <div className="w-11/12 mx-auto">

                <div className="text-center flex mx-auto justify-center w-full rounded-lg mb-3">
                  <div className="relative w-full">
                    <div className="flex absolute inset-y-0 left-0 pl-3 pointer-events-none flex-col">
                      <span className="text-gray text-sm mt-1 mr-2">{t("wallet_address")}</span>
                      <div className="flex">
                        <img className="h-6 w-6 mt-1" src={`/assets/images/wallets/metamask.svg`} alt="coin" />
                      </div>
                    </div>
                    <Selection
                      setValue={setValue}
                      options={options}
                      disabled={loading}
                      theme='dark'
                    />
                  </div>
                </div>

                <div className="text-center text-white flex mx-auto justify-center w-full overflow-hidden rounded-lg ">
                  <div className="relative w-full">
                    <div className="flex absolute inset-y-0 left-0 pl-3 pointer-events-none flex-col">
                      <span className="text-gray text-sm mt-1">{t("amount")}</span>
                      <img className="h-6 w-6 mt-1" src={`/assets/images/items/${unit.toString().toLowerCase()}-icon.webp`} alt="coin" />
                    </div>
                    <input
                      type="text"
                      className="text-sm font-semibold block w-full h-[54px] pl-11 pt-5 text-[#E4E4E4] border border-r-0 border-input bg-[#1F1D24] rounded-l-md"
                      value={amount}
                      onChange={(e: any) => {
                        let value = e.target.value;
                        if (!/^-?\d*\.?\d*$/.test(value)) {
                          return;
                        }
                        value = Number(value) > Number(available) ? available : value;
                        let textValue = utils.toFixed(value).toString();
                        let splitDots = textValue.split(".");
                        if (splitDots.length > 1) {
                          let afterDots = splitDots[1];
                          if (afterDots.length > 8) {
                            return;
                          }
                          if (value < getMinimumToken(unit) && afterDots.length > 7 && getMinimumToken(unit) <= available) {
                            setAmount(utils.toFixed(getMinimumToken(unit)))
                            return;
                          }
                        }
                        value = value.toString();
                        let isFormat = value.substr(value.length - 1);
                        setAmount(isFormat === '.' ? value : Number(value))
                      }}
                      min={getMinimumToken(unit)}
                    />
                  </div>
                  <div
                    className="unselectable bg-[#1F1D24] h-[54px] px-4 text-center pt-[19px] font-medium cursor-pointer text-[#E89F01] border border-l-0 border-input rounded-r-md"
                    style={{
                      // borderLeft: "1px solid #7C6F5F",
                    }}
                    color="yellow"
                    onClick={(evt) => {
                      if (loading) {
                        return;
                      }
                      evt.preventDefault();
                      setAmount(available);
                    }}
                  >
                    {t("max")}
                  </div>
                </div>

                <div className="font-normal text-[#999999] mt-3 text-sm">
                  {t("Balance")}: {" "}
                  <span>
                    <img className="h-6 w-6 mx-1 inline-block" src={`/assets/images/items/${unit.toString().toLowerCase()}-icon.webp`} alt="coin" />
                    {available ? utils.convertToInternationalCurrencySystem(available, 8) : 0} {unit}
                  </span>
                </div>
                {amount < getMinimumToken(unit) && <div className="font-normal text-white-light mt-3 text-sm text-red">
                  {t("Minimum amount")}: {" "}
                  <span>
                    <img className="h-6 w-6 mx-1 inline-block" src={`/assets/images/items/${unit.toString().toLowerCase()}-icon.webp`} alt="coin" />
                    {utils.toFixed(getMinimumToken(unit))} {unit}
                  </span>
                </div>}
                <div className="text-white font-bold mt-2 text-md">
                  You will receive: {" "}
                  {getFeeLoading ?
                    <ImSpinner className="animate-spin inline-block ml-1" /> :
                    <span>
                      <img className="h-6 w-6 mx-1 inline-block" src={`/assets/images/items/${unit.toString().toLowerCase()}-icon.webp`} alt="coin" />
                      {amount && amount > 0 ? utils.convertToInternationalCurrencySystem(amount, 8) : 0} {unit}
                    </span>
                  }
                </div>
              </div>

              <div className="flex w-[112px] gap-4 mt-5 text-center items-center mx-auto">
                <DAOButton
                  color="white"
                  theme="orange"
                  className="py-4"
                  loading={loading}
                  disabled={!amount || getFeeLoading || amount - transactionFee <= 0}
                  onClick={async () => {
                    if (amount >= Config.MinStakeAlert && unit === 'MSTR') {
                      setOpenStakePeriod(true)
                    } else {
                      ui.confirmAction("Confirm action",
                        <>
                          <div className="text-left">
                            This action cannot be undone.
                          </div>
                          <div className="py-2 text-left">
                            Are you sure you want to perform this action?  Please type <em>confirm</em> to confirm you action.
                          </div>
                        </>
                        , "default", async () => await onSubmit())
                    }
                  }}
                >
                  {t("unstake")}
                </DAOButton>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <StakePeriod
        stakeConfig={stakeConfig}
        open={openStakePeriod}
        onClose={() => {
          close();
        }}
        estimateShare={(user?.[CustomerInterface.mstr] ?? 0) / (stakeConfig?.totalMagStakeInGame ?? 1)}
        trigger={trigger}
        setTrigger={setTrigger}
        unstakeAmount={amount}
        unstakeFn={() => {
          ui.confirmAction("Confirm action",
            <>
              <div className="text-left">
                This action cannot be undone.
              </div>
              <div className="py-2 text-left">
                Are you sure you want to perform this action?  Please type <em>confirm</em> to confirm you action.
              </div>
            </>
            , "default", async () => await onSubmit())
        }}
      />
    </>
  );
}
